import React, { useRef } from "react";
import "./Footer.scss";
import { Twitter, Linkedin, Youtube, MapPin, Mail, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import NewsletterDialog from "./NewsletterSection/NewsletterDialog";

const Footer = () => {
  const dialogRef = useRef<HTMLDialogElement>(null);

  return (
    <footer className="landingv2-new-footer">
      <div className="footer-container">
        {/* Newsletter Section */}
        <div className="footer-newsletter">
          <div className="newsletter-content">
            <h2 className="newsletter-title">Stay Ahead of the Market</h2>
            <p className="newsletter-subtitle">Get weekly insights delivered to your inbox</p>
          </div>
          <div className="newsletter-form-container">
            <div className="input-wrapper">
              <button 
                type="button"
                className="newsletter-submit"
                onClick={() => {
                  dialogRef.current?.showModal();
                  document.body.style.overflow = "hidden";
                }}
              >
                Subscribe <ArrowRight size={18} />
              </button>
            </div>
          </div>
        </div>

        <div className="footer-divider top-divider"></div>

        {/* Main Footer Links */}
        <div className="footer-links-grid">
          {/* Brand Column */}
          <div className="footer-brand-col">
            <div className="brand-logo-container">
              {/* <div className="brand-icon-sub"> */}
                <img src="/assets/images/landingv2/main-logo.png" alt="AlgoFabric Logo" className="brand-logo-img" />
              {/* </div> */}
              <div className="brand-powered">POWERED BY ALGOANALYTICS</div>
            </div>
            <p className="brand-description">
              AI-powered financial intelligence for smart investors.<br/>
              Navigate markets with confidence using real-time insights.
            </p>
            <div className="social-icons">
              <a href="https://x.com/AlgoanalyticsIn" target="_blank" rel="noreferrer" className="social-icon">
                <Twitter size={18} />
              </a>
              <a href="https://www.linkedin.com/company/algoanalytics/" target="_blank" rel="noreferrer" className="social-icon">
                <Linkedin size={18} />
              </a>
              <a href="https://www.youtube.com/@algoanalytics5920" target="_blank" rel="noreferrer" className="social-icon">
                <Youtube size={18} />
              </a>
            </div>
          </div>

          {/* Links Columns */}
          <div className="footer-nav-col">
            <h4 className="nav-col-title">PLATFORM</h4>
            <ul className="nav-col-links">
              <li><Link to="/trending">What's Trending</Link></li>
              <li><Link to="/nifty-strategy">Investment Ideas</Link></li>
              <li><Link to="/dashboard">Dashboard</Link></li>
              <li><Link to="/search">Semantic Search</Link></li>
              <li><Link to="/aggregator">News Aggregator</Link></li>
            </ul>
          </div>

          {/* <div className="footer-nav-col">
            <h4 className="nav-col-title">RESOURCES</h4>
            <ul className="nav-col-links">
              <li><Link to="#">Documentation</Link></li>
              <li><Link to="#">API Reference</Link></li>
              <li><Link to="#">Blog</Link></li>
              <li><Link to="#">Case Studies</Link></li>
              <li><Link to="#">Webinars</Link></li>
            </ul>
          </div> */}

          <div className="footer-nav-col">
            <h4 className="nav-col-title">COMPANY</h4>
            <ul className="nav-col-links">
              <li><a href="https://www.algoanalytics.com/" target="_blank" rel="noreferrer">About Us</a></li>
              <li><a href="https://www.algoanalytics.com/careers" target="_blank" rel="noreferrer">Careers</a></li>
              {/* <li><Link to="#">Press</Link></li> */}
              {/* <li><Link to="#">Partner Program</Link></li> */}
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          {/* <div className="footer-nav-col">
            <h4 className="nav-col-title">LEGAL</h4>
            <ul className="nav-col-links">
              <li><Link to="#">Privacy Policy</Link></li>
              <li><Link to="#">Terms of Service</Link></li>
              <li><Link to="#">Cookie Policy</Link></li>
              <li><Link to="#">Disclaimer</Link></li>
            </ul>
          </div> */}
        </div>

        <div className="footer-divider bottom-divider"></div>

        {/* Bottom Bar */}
        <div className="footer-bottom-bar">
          <div className="copyright">
            © 2026 AlgoFabric by AlgoAnalytics. All rights reserved.
          </div>
          <div className="contact-info">
            <a href="mailto:algofabric@algoanalytics.com" className="contact-item">
              <Mail size={16} /> algofabric@algoanalytics.com
            </a>
            <span className="contact-item">
              {/* <MapPin size={16} /> Baner, Pune ,MH India */}
            </span>
          </div>
        </div>

      </div>
      
      <NewsletterDialog dialogRef={dialogRef} />
    </footer>
  );
};

export default Footer;
